"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHeight = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var react_1 = require("react");
var TextArea_styles_1 = require("./TextArea.styles");
var setHeight = function (_a) {
    var shadowRef = _a.shadowRef, textArea = _a.textArea, minRows = _a.minRows, maxRows = _a.maxRows, placeholder = _a.placeholder;
    var shadowTextArea = shadowRef.current;
    if (!shadowTextArea || !textArea)
        return;
    // Copy textarea value to the clone
    shadowTextArea.value = textArea.value || placeholder || 'x';
    var computedStyle = window.getComputedStyle(textArea);
    // If input's width is shrunk and it's not visible, don't sync height.
    if (computedStyle.width === '0px') {
        return;
    }
    shadowTextArea.value = textArea.value || placeholder || 'x';
    // Get the style of the textarea
    shadowTextArea.style.width = computedStyle.width;
    // Calculate the height of a single row
    shadowTextArea.value = 'x';
    var singleRowHeight = shadowTextArea.scrollHeight;
    // Reset the value
    shadowTextArea.value = textArea.value;
    var newHeight = shadowTextArea.scrollHeight;
    if (minRows) {
        newHeight = Math.max(Number(minRows) * singleRowHeight, newHeight);
    }
    if (maxRows) {
        newHeight = Math.min(Number(maxRows) * singleRowHeight, newHeight);
    }
    textArea.style.height = "".concat(newHeight, "px");
};
exports.setHeight = setHeight;
var TextArea = function (_a) {
    var id = _a.id, _b = _a.value, value = _b === void 0 ? '' : _b, label = _a.label, caption = _a.caption, showCharCount = _a.showCharCount, hasError = _a.hasError, _c = _a.width, width = _c === void 0 ? '327px' : _c, _d = _a.minRows, minRows = _d === void 0 ? 3 : _d, maxRows = _a.maxRows, maxLength = _a.maxLength, disabled = _a.disabled, className = _a.className, ref = _a.ref, props = __rest(_a, ["id", "value", "label", "caption", "showCharCount", "hasError", "width", "minRows", "maxRows", "maxLength", "disabled", "className", "ref"]);
    var textAreaRef = (0, react_1.useRef)(null);
    var shadowRef = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(function () {
        var textArea = ref ? ref.current : textAreaRef.current;
        (0, exports.setHeight)({ shadowRef: shadowRef, textArea: textArea, minRows: minRows, maxRows: maxRows, placeholder: props.placeholder });
    }, [value, minRows, maxRows, props.placeholder, ref]);
    (0, react_1.useEffect)(function () {
        var textArea = ref ? ref.current : textAreaRef.current;
        if (!textArea)
            return;
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    (0, exports.setHeight)({ shadowRef: shadowRef, textArea: textArea, minRows: minRows, maxRows: maxRows, placeholder: props.placeholder });
                }
            });
        });
        observer.observe(textArea);
        // eslint-disable-next-line consistent-return
        return function () {
            observer.disconnect();
        };
    }, [ref]);
    return ((0, jsx_runtime_1.jsxs)(TextArea_styles_1.TextAreaRoot, __assign({ className: className, "$width": width }, { children: [(0, jsx_runtime_1.jsxs)(TextArea_styles_1.TextAreaContainer, __assign({ "$hasError": hasError, "$disabled": disabled }, { children: [(0, jsx_runtime_1.jsxs)(TextArea_styles_1.TextAreaWrapper, { children: [(0, jsx_runtime_1.jsx)(TextArea_styles_1.Label, __assign({ htmlFor: id }, { children: label })), (0, jsx_runtime_1.jsx)(TextArea_styles_1.StyledTextArea, __assign({ id: id, value: value, maxLength: maxLength, disabled: disabled, ref: ref || textAreaRef, rows: minRows }, props))] }), hasError && ((0, jsx_runtime_1.jsx)(TextArea_styles_1.IconContainer, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.ExclamationCircle, {}) }))] })), (0, jsx_runtime_1.jsxs)(TextArea_styles_1.CaptionContainer, { children: [(0, jsx_runtime_1.jsx)(TextArea_styles_1.Caption, __assign({ "$hasError": hasError }, { children: caption })), showCharCount && maxLength && ((0, jsx_runtime_1.jsx)(TextArea_styles_1.CharacterCountDown, { children: "Remaining: ".concat(maxLength - value.length) }))] }), (0, jsx_runtime_1.jsx)(TextArea_styles_1.ShadowTextArea, { id: "shadow-textarea", ref: shadowRef, "aria-hidden": true })] })));
};
exports.default = TextArea;
